/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_1_TitleInputs */

const en_homepage_features_note_1_title = /** @type {(inputs: Homepage_Features_Note_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay In The Flow`)
};

const es_homepage_features_note_1_title = /** @type {(inputs: Homepage_Features_Note_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén la concentración`)
};

/**
* | output |
* | --- |
* | "Stay In The Flow" |
*
* @param {Homepage_Features_Note_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_1_title = /** @type {((inputs?: Homepage_Features_Note_1_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_1_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_1_title(inputs)
	return en_homepage_features_note_1_title(inputs)
});